import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV2";
import { ReactNode } from "react";

interface DateFieldProviderProps {
  children: ReactNode;
}

export function DateFieldProvider({ children }: DateFieldProviderProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {children}
    </LocalizationProvider>
  );
}
